import 'angular';
import AppConstants from '../gorillaboy/AppConstants';

interface ShareLinkService {
    getSharedLinkScope: (principals: any[]) => string;
    getShareLink: (linkScope: string, resourceId: string, resourceType: string) => string;
    copyLinkToClipboard: (shareLink: string) => void;
    getLinkPermissionsDetail: (linkScope:string) => string;
}


angular.module('GorillaBoy.services')
    .factory('ShareLinkService', [
    '$location', '$window', '$translate', 'MessageManager', 'MessageProvider',
    function ShareLinkServiceFactory($location: ng.ILocationService, $window: ng.IWindowService, $translate: any,
        MessageManager:any, MessageProvider:any) {
        var collaboratorTypes = AppConstants.CollaboratorTypes,
            sharedLinkScope = AppConstants.SharedLinkScope,
            globalRoles = AppConstants.GlobalRoles,
            resourceTypes = AppConstants.ResourceTypes,
            linkSite = $location.absUrl().split('#')[0];

        function getSharedLinkScope(principals: any[]) {

            for (var i = 0; i < principals.length; i++) {
                var principal = principals[i];

                if(principal.Type === collaboratorTypes.ANONYMOUS) {
                    return sharedLinkScope.ANONYMOUS;

                } else if (principal.Type === collaboratorTypes.ORGANIZATION) {
                    if (principal.Roles[0].Role === globalRoles.VIEWER || principal.Roles[0].Role === 'REVIEWER') {
                        return sharedLinkScope.SITE_VIEWER;

                    } else if (principal.Roles[0].Role === globalRoles.CONTRIBUTOR) {
                        return sharedLinkScope.SITE_CONTRIBUTOR;
                    }
                }
            }

            return null;
        };

        function getShareLink(linkScope: string, resourceId: string, resourceType: string) {
            var shareLink,
                resourceLink = (resourceType === resourceTypes.FOLDER? '#/folder/' : '#/document/');

            switch (linkScope) {
                case sharedLinkScope.ANONYMOUS:
                    shareLink = linkSite + '#/share/document/' + encodeURIComponent(resourceId);
                    break;
                case sharedLinkScope.SITE_VIEWER:
                case sharedLinkScope.SITE_CONTRIBUTOR:
                    shareLink = linkSite + resourceLink + encodeURIComponent(resourceId);
                    break;
            }

            return shareLink;
        };

        function copyLinkToClipboard(shareLink: string) {
            try {
                var textarea = document.createElement('textarea');
                textarea.value = shareLink;
                document.body.appendChild(textarea);
                textarea.select();
                var linkCopySucceeded = document.execCommand('copy');
                document.body.removeChild(textarea);

                if (linkCopySucceeded) {
                    MessageManager.addSuccessMessage(MessageProvider.linkCopied);
                } else {
                    linkCopyFailedHandler();
                }

            } catch (err) {
                linkCopyFailedHandler();
            }

            function linkCopyFailedHandler() {
                // We alert users to use ctrl + c instead.
                $window.alert($translate.instant('MESSAGES.LINK_COPY_CLIPBOARD'));
            }
        }

        function getLinkPermissionsDetail(linkScope:string) {
            var manageLinkDetail,
                scopeDetail;

            switch (linkScope) {
                case sharedLinkScope.ANONYMOUS:
                    scopeDetail = $translate.instant('MODAL.SHARE_MODAL.LINK_SCOPE_PUBLIC');
                    break;
                case sharedLinkScope.SITE_VIEWER:
                    scopeDetail = $translate.instant('MODAL.SHARE_MODAL.LINK_SCOPE_VIEW');
                    break;
                case sharedLinkScope.SITE_CONTRIBUTOR:
                    scopeDetail = $translate.instant('MODAL.SHARE_MODAL.LINK_SCOPE_VIEW_EDIT');
                    break;
            }

            if (scopeDetail) {
                manageLinkDetail = $translate.instant('RIGHT_NAV.PERMISSIONS_PANEL.MANAGE_LINKS_DETAILS', {linkScope: scopeDetail});
            }
            return manageLinkDetail;
        }

        let service: ShareLinkService = {
            getSharedLinkScope: getSharedLinkScope,
            getShareLink: getShareLink,
            copyLinkToClipboard: copyLinkToClipboard,
            getLinkPermissionsDetail: getLinkPermissionsDetail
        };

        return service;
    }]);

export default ShareLinkService;
